export const ProviderTypes = {
  shipping: 'shipping',
  fulfillment: 'fulfillment',
  odbc: 'odbc',
  freight: 'freight',
};

export const ShipStationAppId = 'shipstation';
